import WIDGETS from './widgets';

export default {
  name: 'event_cancel',
	widgets: [{ content: WIDGETS.EVENT_CANCEL, breakpoints: { xs: 12, sm: 12 } }],
};
